import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "auto",
    backgroundColor: "#f4f4f4",
    /**
     * Can usse potision fixed with width as percent
     */
  },
}));

const SimpleLayoutContainer = (props) => {
  const classes = useStyles();
  return <Box className={classes.container}>{props.children}</Box>;
};

export default SimpleLayoutContainer;
